export default IconCircuitVoltmeter => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circuit-voltmeter" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
  <path d="M5 12h-3" />
  <path d="M19 12h3" />
  <path d="M10 10l2 4l2 -4" />
</svg>`;